export default {
  full: /^[a-z]([-']?[a-z]+)*( [a-z]([-']?[a-z]+)*)+$/,
  name: /^[ A-Za-z0-9'-.]*$/
};
